import React from 'react';
import TRP from 'src/components/Shared/TRP/TRP';
import config from 'src/config/config';
import './WhatWillIPayInTaxes.scss';

const WhatWillIPayInTaxes: React.VFC = () => (
  <div className="pay-in-taxes-text">
    <TRP /> does not withhold any tax during this transaction. You may pay taxes
    on any
    <a
      className="text-nowrap"
      href={`${config.url}/usis/my-accounts/taxes`}
      rel="noopener noreferrer"
      target="_blank"
    >
      gains
    </a>
    for this fund when filing your tax return.
    <span>
      {' '}
      Don't worry, we'll send you all relevant tax forms for your <TRP />{' '}
      accounts by mid-February.
    </span>
  </div>
);

export default WhatWillIPayInTaxes;
